import React, { Fragment, useEffect, useState, useContext } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { Link } from "react-router-dom";
import Typography from "@mui/material/Typography";
import "./BusinessCategory.css";
import BusinessCategoryList from "./BusinessCategoryList";
import axios from "axios";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import { Stack } from "@mui/material";
import { useFormik } from "formik";
import * as yup from "yup";
import AuthContext from "../../context/auth/AuthContext";
import FilingMasterContext from "../../context/filing-master/FilingMasterContext";
import CustomDialog from "../common/CustomDialog";
import { TrackNowButton } from "../ui/TrackNowButton";
import { TrackNowTextField } from "../ui/TrackNowTextField";
import { GoogleMaterialIcon } from "../ui/GoogleMaterialIcon";
import { tokens } from "../../theme/tokens";

function Item(props) {
  const { sx, ...other } = props;

  return (
    <Box
      sx={{
        // bgcolor: (theme) => (theme.palette.mode === 'dark' ? '#101010' : '#fff'),
        color: (theme) =>
          theme.palette.mode === "dark" ? "grey.300" : "grey.800",
        // border: '1px solid',
        borderColor: (theme) =>
          theme.palette.mode === "dark" ? "grey.800" : "grey.300",
        p: 1,
        m: 1,
        borderRadius: 2,
        fontSize: "0.875rem",
        fontWeight: "700",
        ...sx,
      }}
      {...other}
    />
  );
}

Item.propTypes = {
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])
    ),
    PropTypes.func,
    PropTypes.object,
  ]),
};

export default function BusinessCategory() {
  const [name, setName] = React.useState("");
  const [actionMode, setActionMode] = React.useState("ADD");
  const [description, setDescription] = React.useState("");
  const [id, setId] = React.useState("");
  const [descriptionRemainingChars, setDescriptionRemainingChars] = useState(150);
  const [isTableLoading, setIsTableLoading] = useState(false);
  const authContext = useContext(AuthContext);
  const { authUserId } = authContext;
  const filingMasterContext = useContext(FilingMasterContext);
  const {
    getBusinessCategories,
    addBusinessCategory,
    updateBusinessCategory,
    filingMasterLoading,
    businessCategories,
  } = filingMasterContext;

  const setEditname = (val) => {
    setName(val.businessCategoryName);
    setDescription(val.businessCategoryDescription);
    setId(val.businessCategoryId);
  };
  const collectData = (from, val) => {
    if (from == "name") {
      setName(val);
    } else {
      setDescription(val);
    }
  };
  const [isUpdated, setIsUpdated] = React.useState(false);

  yup.addMethod(yup.string, "uniqueCategoryName", function (errorMessage) {
    return this.test(`test-unique-category`, errorMessage, function (value) {
      const { path, createError } = this;
      console.log("Chcking ID", formik.values.businessCategoryId);
      if (formik.values.businessCategoryId) return true;
      return (
        businessCategories.findIndex(
          (item) =>
            item.businessCategoryName.toLowerCase() === value.toLowerCase()
        ) < 0 || createError({ path, message: errorMessage })
      );
    });
  });

  const validationSchema = yup.object({
    businessCategoryName: yup
      .string()
      .min(2, "Name is too Short!")
      .max(100, "Name is too Long!")
      .uniqueCategoryName("Name must be unique")
      .required("Category Name is required"),

    businessCategoryDescription: yup
      .string()
      .required("Description is required"),
  });

  const initForm = {
    businessCategoryId: 0,
    businessCategoryName: "",
    businessCategoryDescription: "",
    createdDate: null,
    createdUser: "",
    updateDate: null,
    updateUser: "",
  };
  const [category, setCategory] = React.useState(initForm);
  const [alertMessage, setAlertMessage] = React.useState("");
  const [showAlert, setShowAlert] = React.useState(false);
  const [showConfirm, setShowConfirm] = React.useState(false);
  const [alert, setAlert] = useState({ title: "Information", type: "info" });

  const handleSubmit = () => {
    console.log("Submitting....");
  };

  const closeConfirm = () => {
    console.log("Cancelling....");
  };

  const formik = useFormik({
    initialValues: initForm,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      // alert(JSON.stringify(values, null, 2));
      submitForm();
    },
  });

  const submitForm = async () => {
    setIsTableLoading(true);
    console.log("Submitting....");
    try {
      if (actionMode === "ADD") {
        let _cat = { ...formik.values };
        delete _cat.businessCategoryId;
        delete _cat.updateUser;
        delete _cat.updateDate;
        _cat.createdDate = new Date();
        _cat.createdUser = authUserId;

        const res = await addBusinessCategory([_cat]);
        if (res) {
          setAlertMessage(
            <Typography>
              Successfully Added Business Category: {" "}
              <Typography fontWeight="bold" component="span">
                {formik.values.businessCategoryName}
              </Typography> {" "}
            </Typography>
          );
          setShowAlert(true);
          formik.resetForm();
          setDescriptionRemainingChars(150);
          // navigate("/");
        }
      } else if (actionMode === "EDIT") {
        console.log("Submitting Edit....");
        let _cat = { ...formik.values };
        _cat.updateDate = new Date();
        _cat.updateUser = authUserId;
        const res = await updateBusinessCategory(_cat);
        if (res) {
          setActionMode(() => "ADD");
          setAlertMessage(
            <Typography>
              Successfully Updated Business Category: {" "}
              <Typography fontWeight="bold" component="span">
                {formik.values.businessCategoryName}
              </Typography> {" "}
            </Typography>
          );
          setShowAlert(true);
          formik.resetForm();
          setDescriptionRemainingChars(150);
          // navigate("/");
        }
      }
    } catch (error) {
      setAlertMessage("Unexpected Error Occured");
      setShowAlert(true);
      console.log("Setting Alert to =>", `Unexpected Error Occured`);
      setAlert((old) => ({
        ...old,
        message: "Unexpected Error Occured",
      }));
      setShowConfirm(true);
      setDescriptionRemainingChars(150);
    } finally {
      setIsTableLoading(false);
    }
  };

  // useEffect(() => {
  //   // toggleDrawer(props.dockAt, props.show);
  //   if (selectedCustomer !== null) {
  //     const _cust = {
  //       customerId:
  //         selectedCustomer && selectedCustomer.customerId
  //           ? selectedCustomer.customerId
  //           : 0,
  // formik.setValues(_cust);
  //     //eslint-disable-next-line
  //   }, []);

  // const updateData = () => {
  //   let data = {
  //     businessCategoryId: id,
  //     businessCategoryName: name,
  //     businessCategoryDescription: description,
  //     createdDate: "2023-03-17T06:21:07.265Z",
  //     createdUser: "string",
  //     updateDate: new Date(),
  //     updateUser: "string",
  //   };
  //   axios
  //     .put(
  //       "https://localhost:7005/api/Application/BusinessCategoryMasterUpdate" +
  //         id,
  //       data
  //     )
  //     .then((res) => {
  //       setIsUpdated(true);
  //     });
  // };

  const closeAlert = () => {
    setShowAlert(false);
    // navigate("/");
  };

  const selectRowForEdit = (editRecord) => {
    console.log("ROW Selected for Edit:", editRecord);
    setActionMode(() => "EDIT");
    formik.setValues(editRecord);
  };
  const formReset = () => {
    formik.resetForm();
    setActionMode(() => "ADD");
  };
  return (
    <Grid container spacing={2} sx={{ width: "100%", px: { xs: 2, md: 3 }, alignItems: "stretch" }}>

      {/* LEFT FORM */}
      <Grid xs={12} md={4}>
        <Box
          sx={{
            backgroundColor: tokens.colors.offWhite,
            borderRadius: "8px",
            padding: "2rem",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            mt: 2,
            height: { xs: "auto", md: "72vh" },
            display: "flex",
            flexDirection: "column",
          }}
        >
          <form onSubmit={formik.handleSubmit} noValidate>

            <TrackNowTextField
              required
              id="businessCategoryName"
              name="businessCategoryName"
              label="Business Category Name"
              placeholder="Max-Length 100 characters"
              fullWidth
              value={formik.values.businessCategoryName}
              onChange={formik.handleChange}
              error={
                formik.touched.businessCategoryName &&
                Boolean(formik.errors.businessCategoryName)
              }
              helperText={
                formik.touched.businessCategoryName &&
                formik.errors.businessCategoryName
              }
              sx={{ mb: 2 }}
            />

            <TrackNowTextField
              required
              id="businessCategoryDescription"
              name="businessCategoryDescription"
              label="Description"
              placeholder="Enter Description (Max 150 Characters)"
              fullWidth
              multiline
              minRows={3}
              maxRows={8}
              inputProps={{
                maxLength: 150,
                style: {
                  overflow: 'auto',
                  wordBreak: 'break-word',
                  overflowWrap: 'break-word',
                },
              }}
              value={formik.values.businessCategoryDescription}
              onChange={(e) => {
                if (e.target.value.length <= 150) {
                  formik.handleChange(e);
                  setDescriptionRemainingChars(150 - e.target.value.length);
                }
              }}
              error={
                formik.touched.businessCategoryDescription &&
                Boolean(formik.errors.businessCategoryDescription)
              }
              helperText={
                formik.touched.businessCategoryDescription &&
                formik.errors.businessCategoryDescription
              }
              sx={{
                mb: 2,
                '& .MuiInputBase-inputMultiline': {
                  resize: 'none',
                },
              }}
            />
            <Typography
              sx={{
                fontSize: '11px',
                fontWeight: 'small',
                color:
                  descriptionRemainingChars === 0 ? 'red' : 'inherit',
                display:
                  descriptionRemainingChars === 150 ? 'none' : 'block',
              }}
            >
              {descriptionRemainingChars} Characters are left
            </Typography>
            <Stack direction="row" justifyContent="flex-end">
              <TrackNowButton
                variant="primary"
                onClick={() => {
                  formik.setTouched({
                    businessCategoryName: true,
                    businessCategoryDescription: true,
                  });
                  formik.handleSubmit();
                }}
              >
                {actionMode.charAt(0) + actionMode.slice(1).toLowerCase()}
              </TrackNowButton>
            </Stack>

          </form>
        </Box>
      </Grid>

      {/* RIGHT TABLE */}
      <Grid xs={12} md={8} sx={{ display: "flex" }}>
        <Box sx={{ width: "100%", height: { xs: "auto", md: "72vh" }, display: "flex", flexDirection: "column" }}>
          <BusinessCategoryList
            selectRowForEdit={selectRowForEdit}
            isTableLoading={isTableLoading}
            formReset={formReset}
          />
        </Box>
      </Grid>

      <CustomDialog header="Info" visible={showAlert} onHide={closeAlert} footer={null}>
        <p className='m-0'>{alertMessage}</p>
      </CustomDialog>    </Grid>
  );
}

